import { cn } from '@/lib/utils'
import { useIntersectionObserver } from '@/hooks/use-intersection-observer'
import { Crown, TrendingUp, Globe, Award } from 'lucide-react'

export const SocialProofSection = () => {
  const { elementRef, isVisible } = useIntersectionObserver()

  const giants = [
    {
      icon: Crown,
      label: 'Liderança de Mercado',
    },
    {
      icon: TrendingUp,
      label: 'Escala Acelerada',
    },
    {
      icon: Globe,
      label: 'Operação Global',
    },
    {
      icon: Award,
      label: 'Elite Comprovada',
    },
  ]

  return (
    <section
      ref={elementRef}
      className="py-16 md:py-24 bg-[#0A0A0A] border-y border-white/5"
    >
      <div className="container mx-auto px-4 sm:px-6">
        <div
          className={cn(
            'text-center mb-10 md:mb-20 transition-all duration-1000 transform',
            isVisible
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-10',
          )}
        >
          <p className="text-primary font-bold tracking-[0.2em] uppercase mb-3 md:mb-4 text-xs sm:text-sm md:text-base">
            Vagas Limitadas para Junho
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-heading font-black text-white uppercase tracking-tight text-balance">
            Junte-se aos gigantes do mercado
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 md:gap-12 max-w-6xl mx-auto">
          {giants.map((item, idx) => (
            <div
              key={idx}
              className={cn(
                'flex flex-col items-center gap-3 md:gap-6 group transition-all duration-700 delay-100',
                isVisible
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 translate-y-8',
              )}
              style={{ transitionDelay: `${idx * 150}ms` }}
            >
              <div className="p-4 md:p-6 rounded-xl md:rounded-2xl bg-white/5 border border-white/10 group-hover:border-primary/50 group-hover:bg-primary/10 transition-all duration-500 ease-out transform group-hover:-translate-y-2">
                <item.icon
                  className="w-8 h-8 md:w-14 md:h-14 text-white/80 group-hover:text-primary transition-colors duration-300"
                  strokeWidth={1.5}
                />
              </div>
              <span className="text-xs sm:text-sm md:text-lg font-heading font-bold text-white/60 uppercase tracking-widest text-center group-hover:text-white transition-colors duration-300">
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
